import Backbone from "backbone";
import _ from "underscore";
export default Backbone.View.extend({
  template: _.template(
    '<label id="toggleStatusShown" class="control-label green-text" style="display: none;">Shown&nbsp;</label><label id="toggleStatusHidden" class="control-label" style="display: none;">Hidden&nbsp;</label><label class="switch"><input type="checkbox" <% if(this.model.get("visible")){ %> checked <% } %> ><span class="slidernew round"></span></label>'
  ),

  initialize: function (options) {
    this.options = options;
    this.model = this.options.model;
  },
  render: function () {
    this.$el.html(this.template(this.options));
    if (this.model.get("visible")) {
      this.$("#toggleStatusShown").show();
    } else {
      this.$("#toggleStatusHidden").show();
    }
  },
  events: {
    "click label span": "clicked",
  },
  clicked: function () {
    var value = this.model.get("visible");
    if (value == "undefined") {
      value = false;
    }
    this.model.set("visible", !value);

    if (!value) {
      this.$("#toggleStatusShown").show();
      this.$("#toggleStatusHidden").hide();
    } else {
      this.$("#toggleStatusShown").hide();
      this.$("#toggleStatusHidden").show();
    }
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/ToggleInput.js
// module id = 891
// module chunks = 1